
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/react-container",
      function () {
        return require("private-next-pages/system/react-container.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/react-container"])
      });
    }
  